import React, { useRef, useEffect } from 'react';

function NativeSelect(props) {
  var ref = useRef(null);
  var value = props.value || '';
  var onChange = props.onChange;
  var options = props.options || [];
  var placeholder = props.placeholder || 'Select...';
  var className = props.className || '';
  var testId = props.testId || '';

  useEffect(function () {
    var el = ref.current;
    if (!el) return;
    while (el.options.length > 0) el.remove(0);
    var placeholderOpt = document.createElement('option');
    placeholderOpt.value = '';
    placeholderOpt.textContent = placeholder;
    el.appendChild(placeholderOpt);
    for (var i = 0; i < options.length; i++) {
      var opt = document.createElement('option');
      opt.value = options[i].value;
      opt.textContent = options[i].label;
      el.appendChild(opt);
    }
    el.value = value;
  }, [options, placeholder, value]);

  useEffect(function () {
    var el = ref.current;
    if (el) el.value = value;
  }, [value]);

  return React.createElement('select', {
    ref: ref,
    className: className,
    'data-testid': testId,
    onChange: function (e) {
      if (onChange) onChange(e.target.value);
    }
  });
}

export default NativeSelect;
